/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';

const AspectLimiter = ({ aspect, children, ...props }) => {
	const [dim, setDim] = useState({ flexBasis: '100%', height: '100%' });
	const onResize = useCallback(
		(width, height) => {
			if (width * aspect > height) {
				setDim({ flexBasis: Math.floor(height / aspect) + 'px', height: Math.floor(height) + 'px' });
			} else {
				setDim({ flexBasis: '100%', height: Math.floor(width * aspect) + 'px' });
			}
		},
		[aspect, setDim]
	);
	const { ref } = useResizeDetector({ onResize });

	return (
		<div
			css={css`
				position: relative;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			`}
			{...props}
		>
			<div
				ref={ref}
				css={css`
					position: absolute;
					pointer-events: none;
					width: 100%;
					height: 80vh;
				`}
			></div>
			<div style={dim}>{children}</div>
		</div>
	);
};

export default AspectLimiter;
